<template>
  <component
    :is="component"
    v-if="product"
    :image-type="imageType"
    :product="product"
    :show-play-product="showPlayProduct"
    :class="{
      'is-current': isCurrentProduct(product),
      'is-highlighted': isCurrentArticle(product),
    }"
    class="js-slider-item"
    @highlight-viewport-leave="onHighlightViewportLeave"
    @trailer-ended="onTrailerEnded"
  ></component>
  <div
    v-else-if="productsArray"
    class="c-tile-two-lines__wrapper js-slider-item"
  >
    <template v-for="productItem in productsArray">
      <component
        :is="component"
        :key="productItem.id"
        :image-type="imageType"
        :product="productItem"
        :class="{
          'is-current': isCurrentProduct(productItem),
          'is-highlighted': isCurrentArticle(productItem),
        }"
      ></component>
    </template>
  </div>
</template>
<script>
  import { TileLayout } from '@/shared/enums';
  import layouts from './layouts';

  export default {
    inject: ['$section'],
    props: {
      layout: String,
      imageType: String,
      product: Object,
      showPlayProduct: Boolean,
      productsArray: Array,
    },
    computed: {
      component() {
        return layouts[this.tileLayout];
      },
      tileLayout() {
        return this.layout || TileLayout.DEFAULT;
      },
    },
    methods: {
      isCurrentProduct(product) {
        return parseInt(this.$route.params.id, 10) === product.id;
      },
      isCurrentArticle(product) {
        if (!this.$section.showHighlight) {
          return;
        }

        return parseInt(this.$route.params.articleId, 10) === product.id;
      },
      onTrailerEnded() {
        this.$emit('trailer-ended');
      },
      onHighlightViewportLeave() {
        this.$emit('highlight-viewport-leave');
      },
    },
  };
</script>
